import { render, staticRenderFns } from "./Select.form-builder.vue?vue&type=template&id=f2178aaa&scoped=true&"
import script from "./Select.form-builder.vue?vue&type=script&lang=js&"
export * from "./Select.form-builder.vue?vue&type=script&lang=js&"
import style0 from "./Select.form-builder.vue?vue&type=style&index=0&id=f2178aaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2178aaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
